// src/axios/publicAxios.js

import axios from "axios";

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_RUN_DOCKER === 'TRUE' ? process.env.REACT_APP_DOCKER_API_URL : process.env.REACT_APP_API_URL,
    withCredentials: true
})